package com.exura.pages.publicplans.widgets

import androidx.compose.runtime.Composable
import com.exura.components.pageTypography.ExuraBodyHeaderTextVariant
import com.exura.components.pageTypography.ExuraCommentaryTextVariant
import com.exura.components.pageTypography.ExuraSuccessTextVariant
import com.exura.components.pageTypography.ExuraTextStyle
import com.exura.components.pageTypography.ExuraWarnTextVariant
import com.exura.components.pageTypography.UnderwrittenText
import com.exura.features.publicplans.publicPlansLocalization
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun PublicPlanSharingEnabledWidget(
    accessCode: String,
    isSharingEnabled: Boolean,
) = UnderwrittenText(
    topVariant = ExuraBodyHeaderTextVariant,
    underwrite = {
        Row {
            SpanText(
                "${publicPlansLocalization.current.planSharing.sharing}: ",
                modifier = ExuraTextStyle
                    .toModifier(ExuraCommentaryTextVariant)
            )
            SpanText(
                if (isSharingEnabled)
                    publicPlansLocalization.current.planSharing.active
                else publicPlansLocalization.current.planSharing.inactive,
                modifier = ExuraTextStyle
                    .toModifier(
                        if (isSharingEnabled) ExuraSuccessTextVariant else ExuraWarnTextVariant
                    )
            )
        }
    },
) {
    SpanText(accessCode)
}
